import { addCommentsConstant } from "../constants";

let initialState = {
    responseCode: "",
    error: "",
    response: ""
}

export const addComments_Reducer = (state = initialState, action) => {
    switch (action.type) {
        case addCommentsConstant.ADD_NEW_COMMENTS_SUCCESS:
            return {
                ...state,
                response: action.payload.data,
                responseCode: action.payload.status
            }
        case addCommentsConstant.ADD_NEW_COMMENTS_FAILURE:
            return {
                ...state,
                response: action.payload.data,
                responseCode: action.payload.status
            }
        default:
            return state;
    }
}